import { render, staticRenderFns } from "./menuItems.vue?vue&type=template&id=3d666d18&"
import script from "./menuItems.vue?vue&type=script&lang=js&"
export * from "./menuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports